import { useRef, lazy, Suspense } from 'react';
import Footer from '@/components/Footer';
import getMetadata from '@/utils/getMetadata';
import { NextSeo } from 'next-seo';
import localeManager from '@/utils/localeManager';
import useLangMenuBar from "@/hooks/useLangMenuBar";

const TerminosYCondiciones = ({ locale, footer, menu }) => {

  const Body = lazy(() => import(`@/locales/components/${locale}/TerminosCondiciones`))

  const root = useRef();
  

  return (
    <main ref={root} className="relative site-max mx-auto condiciones">
      <NextSeo
        {...getMetadata({
          locale,
          title: 'Términos y condiciones',
          description: 'Conocé nuestros términos y condiciones.',
          pathname: '/terminos-y-condiciones'
        })}
      />
      <Suspense fallback={<div>Cargando...</div>}>
        <Body />
      </Suspense>
        <Footer footer={footer} locale={locale} />
    </main>
  );
};

export default TerminosYCondiciones;

export async function getServerSideProps({ req, locale: nextLocale, defaultLocale }) {
  const { locale, dict } = await localeManager.getLocaleResources(req, {}, nextLocale || defaultLocale);

  return {
      props: {
        locale,
        footer: dict.home.footer,
        menu: dict.menu
      }
  }
}
